import { Component, Input, OnInit } from '@angular/core';
import { GalleryType, SkeletonSizeBase } from '../../../common';
import { Grid } from '../../../common/Models/Models';

@Component({
  selector: 'skc-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.less']
})
export class GalleryComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-gallery-type') galleryType = GalleryType.GRID;
  @Input('skc-animation') animation;
  @Input('skc-grid') grid: Grid = {
    cols: [{ rows: [30, 70] }, { rows: [70, 30] }, { rows: [30, 70] }]
  };
  @Input('skc-height') height;
  @Input('skc-total') total = 6;
  @Input('skc-responsive') responsive = true;

  enumGallery = GalleryType;
  constructor() {
    super();
  }

  ngOnInit() {}
}
